import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qr-view-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Success!")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Your Public Opt meeting page has been created. You can access it any time by tapping the Account Icon in the top right of the screen and selecting the Opt Meeting Page.")
  ])
], -1 /* HOISTED */)
const _hoisted_3 = { class: "qr-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "qr-description" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Scan Code for a preview of what others will see.")
], -1 /* HOISTED */)
const _hoisted_5 = { class: "button-section" }
const _hoisted_6 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_3, [
        ($setup.inviteLink)
          ? (_openBlock(), _createBlock($setup["QrCode"], {
              key: 0,
              message: $setup.inviteLink
            }, null, 8 /* PROPS */, ["message"]))
          : _createCommentVNode("v-if", true)
      ]),
      _hoisted_4
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          class: "back",
          onClick: $setup.moveBack
        }, "Back"),
        _createElementVNode("button", {
          class: "primary continue",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('progress')))
        }, "Continue")
      ])
    ])
  ]))
}